import styled from 'styled-components'
import {
  colors,
  breakpoints,
} from '../../styles/base/_allBase.styles'

const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

/**
 * Outer page container — centres the content and adds responsive horizontal
 * padding.  On large screens it flips to a side-by-side layout:
 *   [PanelWrap ~320px sticky] | [BodyWrap flexible]
 */
export const ArticleMain = styled.div`
  max-width: ${({ $variant }) => $variant === 'article' ? '1320px' : '1180px'};
  margin: 0 auto;
  padding: 2.5rem 4vw 4rem;
  width: 100%;
  box-sizing: border-box;

  @media ${xxSmallDevices} {
    padding: 1.5rem 1rem 2.5rem;
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    padding: 1.5rem 1.25rem 3rem;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    padding: 2.5rem 2rem 3.5rem;
  }
  @media ${mediumDevicesLandscape} {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 2.5rem;
    padding: 3rem 2rem 4rem;
  }
  @media ${largeDevices} {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 3rem;
    padding: 3.5rem 2rem 5rem;
  }
  @media ${extraLargeDevices} {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 4rem;
    padding: 3.5rem 0 5rem;
  }
  @media ${xxLargeDevices} {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 4rem;
    padding: 3.5rem 0 5rem;
  }
`

/**
 * Sidebar wrapper — stacks above the body on mobile/tablet, sits on the left
 * on large screens as a sticky column.
 */
export const PanelWrap = styled.div`
  width: 100%;
  margin-bottom: 2rem;

  @media ${xxSmallDevices} {
    margin-bottom: 1.5rem;
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
    margin-bottom: 1.5rem;
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    margin-bottom: 2rem;
  }
  @media ${mediumDevicesLandscape} {
    flex: 0 0 280px;
    max-width: 280px;
    width: auto;
    margin-bottom: 0;
    position: sticky;
    top: 9rem;
    align-self: flex-start;
  }
  @media ${largeDevices} {
    flex: 0 0 300px;
    max-width: 300px;
    width: auto;
    margin-bottom: 0;
    position: sticky;
    top: 9rem;
    align-self: flex-start;
  }
  @media ${extraLargeDevices} {
    flex: 0 0 320px;
    max-width: 320px;
    width: auto;
    margin-bottom: 0;
    position: sticky;
    top: 9rem;
    align-self: flex-start;
  }
  @media ${xxLargeDevices} {
    flex: 0 0 320px;
    max-width: 320px;
    width: auto;
    margin-bottom: 0;
    position: sticky;
    top: 9rem;
    align-self: flex-start;
  }
`

/**
 * Main article body — constrained reading measure on large screens so long-form
 * copy stays comfortable at ~72ch.
 */
export const BodyWrap = styled.div`
  width: 100%;
  min-width: 0; /* prevents flex-child overflow */

  /* Prose rhythm: headings + paragraphs inside blog content sections */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Whyte-Bold', sans-serif;
    color: ${colors.warmPalette.primaryDark};
    margin-top: 2em;
    margin-bottom: 0.5em;
    line-height: 1.25;
  }

  p {
    font-size: 1.7rem;
    line-height: 1.75;
    margin-bottom: 1.25em;
    color: ${colors.neutralPalette.black};
  }

  a {
    color: ${colors.warmPalette.primary};
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${mediumDevicesLandscape} {
    flex: 1 1 0%;
    max-width: ${({ $variant }) => $variant === 'article' ? 'none' : '72ch'};
  }
  @media ${largeDevices} {
    flex: 1 1 0%;
    max-width: ${({ $variant }) => $variant === 'article' ? 'none' : '72ch'};
  }
  @media ${extraLargeDevices} {
    flex: 1 1 0%;
    max-width: ${({ $variant }) => $variant === 'article' ? 'none' : '72ch'};
  }
  @media ${xxLargeDevices} {
    flex: 1 1 0%;
    max-width: ${({ $variant }) => $variant === 'article' ? 'none' : '72ch'};
  }
`
